import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, catchError, map, Observable, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomizeCookieService } from './customize-cookie.service';
import { ToastrService } from 'ngx-toastr';
import { nvlBool, nvlby, nvlNull, nvlObj, nvlZero } from 'src/app/core/services/utils.service';
import { LocalStorageHandler } from "src/app/shared/services/local-storage"

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private CLIENT_ID = 'eatl-his-client-id-password';
  private PASSWORD = 'eatl-his-auth-secret';
  private GRANT_TYPE = 'password';
  private BASE_URL = environment.baseUrl;
  private API_URL = environment.authApiUrl;
  private END_POINT = '/oauth/token';
  private AUTH_URL = `${this.BASE_URL}${this.API_URL}${this.END_POINT}`;
  private USER_DETAILS = this.BASE_URL + this.API_URL + '/api/user/user-details-info';
  private AUTH_MENU_LIST = `${this.BASE_URL}${this.API_URL}/api/user/auth-menu`;
  private VALIDATE_ROUTE = `${this.BASE_URL}${this.API_URL}/api/user/validate-route`;
  private VALIDATE_TOKEN = `${this.BASE_URL}${this.API_URL}/api/user/validate-token`;


  public _isLoading = false;
  private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public errorMgs: BehaviorSubject<string> = new BehaviorSubject('');
  private isCompletedUserDetails: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public facilitySwitchFlag = false;
  public userDetils: any = {};
  public localStorageObj: any = {}
  private localStorageHandler: LocalStorageHandler = new LocalStorageHandler();

  get isLoggedIn() {
    this.checkCredentials();
    return this.loggedIn.asObservable();
  }

  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private cookieService: CookieService,
    private cookie: CustomizeCookieService,
    private toast: ToastrService
  ) { }

  public loadingStatus(): Observable<boolean> {
    return this.isLoading.asObservable();
  }

  public isCompleteUserDetail(): Observable<boolean> {
    return this.isCompletedUserDetails.asObservable();
  }

  public getAccessToken(): any {
    return this.cookie.get('routeKey');
  }

  public refreshAccessToken(): Observable<any> {
    return of(this.obtainNewAccessToken()).pipe();
  }

  public checkCredentials() {
    if (!this.cookie.get('routeKey')) {
      this.loggedIn.next(false);
    } else {
      this.loggedIn.next(true);
    }
  }

  // if want to backend access token validation
  // public checkCredentials() {

  //   this.validateToken().subscribe(
  //     res=>{
  //       console.log(res);
  //       if(res.success){
  //         this.loggedIn.next(true);
  //       }else{
  //          this.loggedIn.next(false);
  //       }

  //     }
  //   ) 
  // }


  public obtainNewAccessToken(): Observable<any> {
    return new Observable;
  }

  public login(user: any, switchFlag: boolean) {

    this.facilitySwitchFlag = switchFlag;
    this._isLoading = true;
    this.isLoading.next(this._isLoading);

    let params = new HttpParams()
      .set('username', user.userName)
      .set('password', user.password)
      .set('grant_type', this.GRANT_TYPE)
      .set('client_id', this.CLIENT_ID);

    const headers = {
      'Authorization': 'Basic ' + btoa(`${this.CLIENT_ID}:${this.PASSWORD}`),
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
    }

    this.httpClient.post<any>(this.AUTH_URL, params.toString(), { headers, withCredentials: true })
      .subscribe((res: any) => {
        this.saveToken(res);
      }, err => {
        const error = nvlObj(err.error)
        // this._isLoading = false;
        // this.isLoading.next(this._isLoading);
        // let errorMessage: any = null;
        // if (error.error_description == 'Bad credentials') {
        //   errorMessage = 'Invalid username or password';
        // } else {
        //   errorMessage = error.error_description;
        // }
        // this.errorMgs.next(errorMessage);

        this._isLoading = false;
        this.isLoading.next(this._isLoading);
        this.errorMgs.next(nvlNull(nvlObj(error).error));
      }
      )
  }

  public messStatus(): Observable<string> {
    return this.errorMgs.asObservable();
  }

  public saveToken(token: any) {
    var expireDate = token.expires_in;
    this.cookie.setWithExpiryInSeconds("routeKey", 'true', expireDate);
    this.setUserInfo();
  }

  public getCurrentUserInfo(): Observable<any> {
    return this.httpClient.get<any>(this.USER_DETAILS, <any>{});

  }

  public setUserInfo(): void {
    this.isCompletedUserDetails.next(false);
    this.httpClient.get<any>(`${this.USER_DETAILS}`, <any>{}).subscribe(
      (res: any) => {
        /*Loader false*/
        this.isCompletedUserDetails.next(true);
        this._isLoading = false;
        this.isLoading.next(this._isLoading);
        this.errorMgs.next('');
        /*Loader false*/
        const _userInfo = nvlNull(res.obj);
        if (_userInfo) {

          this.localStorageHandler.setUserHeaderInformationFromUser(_userInfo);
          this.localStorageHandler.setUserOrganizationInformationFromUser(_userInfo);
          if (nvlBool(_userInfo.pwdChangeRequired) == 1) {
            this.redirectTo('/pwd-change-required');
            return;
          } else if (_userInfo.defaultPageLink) {

            const url = nvlNull(nvlby(_userInfo.defaultPageLink, '').split(';feature=')[0]);
            const featureNo = nvlNull(nvlby(_userInfo.defaultPageLink, '').split(';feature=')[1]);

            this.router.navigate([url, { feature: featureNo }]);
          } else {
            this.redirectTo('/')
          }
        } else {
          this.localStorageHandler.setUserHeaderInformationFromUser(null);
          this.localStorageHandler.setUserOrganizationInformationFromUser(null);

          this.redirectTo('/')
        }
      },
      err => {
        this.localStorageHandler.setUserHeaderInformationFromUser(null);
        this.localStorageHandler.setUserOrganizationInformationFromUser(null);

        this.router.navigate(['/']);
        console.log('Error : ', err);
      })
  }

  public redirectTo(uri: string) {
    if (this.facilitySwitchFlag) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate([uri]));
    } else {
      this.router.navigate([uri]);
    }
  }

  public getAuthMenu(): Observable<any> {
    return this.httpClient.get<any>(this.AUTH_MENU_LIST).pipe(
      map((data: any) => data));
  }

  public validateToken(): Observable<any> {
    return this.httpClient.get(this.VALIDATE_TOKEN, { withCredentials: true });
  }

  public validateRoute(featureNo: any): Observable<any> {
    return this.httpClient.get(this.VALIDATE_ROUTE, { params: new HttpParams().set('featureNo', featureNo), withCredentials: true });
  }

  public logout() {
    const routeKey = this.cookieService.get('routeKey');
    this.deleteToken(routeKey).subscribe(
      res => {
        this.clearAndRedirect();
        if (res.success) {
          this.toast.success(res.message);
        } else {
          // this.toast.warning(res.message);
        }
      }, err => {
        this.clearAndRedirect();
        console.log(err);
      }
    )
  }

  public deleteToken(routeKey: any): Observable<any> {
    const headers = {
      'Authorization': 'Bearer ' + routeKey,
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
    };
    const deleteAPIURL = `${this.BASE_URL}${this.API_URL}${this.END_POINT}/logout`;
    return this.httpClient.delete<any>(deleteAPIURL, { headers, withCredentials: true }).pipe(
      map((res: Response) => res),
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }

  public clearAndRedirect() {
    localStorage.clear();
    this.cookie.deleteAccessToken();
    this.router.navigate(['/']);
    setTimeout(function () { location.reload() }, 500)
  }

  public updateTokenInfo(reqObj: any): Observable<any> {
    const upURL = `${this.BASE_URL}${this.API_URL}/api/token-info/update`;
    return this.httpClient.post(upURL, reqObj);
  }

  public customerInfo(reqObj: any): Observable<any> {
    const headers = {
      'Authorization': 'Bearer ' + this.cookieService.get('routeKey'),
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
    };
    const upURL = `${this.BASE_URL}${this.API_URL}/api/customer/info`;
    return this.httpClient.post(upURL, reqObj, { headers });
  }


}
